// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tabs_wrapper__R10RF","tabMenu":"Tabs_tabMenu__wd2vO"};